/* global module, require */
const crel = require('./createElement'),
	empty = require('./emptyElement');

const routes = ['Facebook', 'Twitter', 'other'];

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
const time = ['10AM - 12PM', '12PM - 2PM', '2PM - 4PM'];

function PlannerDetails(parent) {
	this.name = 'Details';
	this.parent = parent;
	this.data = {};
	this.inputs = [];

	this.change = this.change.bind(this);

	this.container = crel({ className: 'planner-choose-details' });
	crel({
		_parent: this.container,
		_tag: 'h2',
		innerText: 'Please enter your details',
	});

	this.addInput('name', 'Your Name*');
	this.addInput('email', 'Email*', 'email');
	this.addInput('phone', 'Phone*');
	this.addSelect('route', 'How did you hear about us?', routes);
	this.addSelect('day', 'Best Day to contact', days, 'day-time-select');
	this.addSelect('time', 'Best Time to contact', time, 'day-time-select');
	this.addText('comments', 'Comments', 'textarea');
}

PlannerDetails.prototype.activate = function() {
	empty(this.parent.content);
	this.parent.content.appendChild(this.container);
};

PlannerDetails.prototype.addLabel = function(innerText, additionalClass = '') {
	return crel({
		_tag: 'label',
		_parent: this.container,
		className: 'row large ' + additionalClass,
		innerText,
	});
};

PlannerDetails.prototype.addInput = function(
	name,
	text,
	type = 'text',
	required = true
) {
	const label = this.addLabel(text);
	const input = crel({
		_tag: 'input',
		_parent: label,
		name,
		type,
		required,
		onchange: this.change,
	});

	this.inputs.push(input);
	return input;
};

PlannerDetails.prototype.addText = function(
	name,
	text,
	type = 'textarea',
	required = false
) {
	const label = this.addLabel(text);
	const tarea = crel({
		_tag: 'textarea',
		_parent: label,
		name,
		type,
		required,
		onchange: this.change,
	});

	this.inputs.push(tarea);
	return tarea;
};

PlannerDetails.prototype.addSelect = function(
	name,
	text,
	options,
	newClass,
	required = false
) {
	const label = this.addLabel(text, newClass);
	const selectWrapper = crel({ _parent: label, className: 'select-wrapper' });
	const select = crel({
		_tag: 'select',
		_parent: selectWrapper,
		name,
		required,
		onchange: this.change,
	});
	crel({ _tag: 'option', _parent: select, innerText: 'Select Option' });
	options.forEach(o =>
		crel({ _tag: 'option', _parent: select, innerText: o, value: o })
	);

	this.inputs.push(select);
	return select;
};

PlannerDetails.prototype.change = function(e) {
	this.data[e.currentTarget.name] = e.currentTarget.value;
};

PlannerDetails.prototype.validate = function() {
	var invalid = null;

	this.inputs.forEach(input => {
		if (!input.checkValidity()) {
			invalid = invalid || input;
			input.classList.add('error');
		} else input.classList.remove('error');
	});

	if (invalid) invalid.reportValidity();
	return invalid === null;
};

PlannerDetails.prototype.complete = function() {
	return this.validate();
};

module.exports = PlannerDetails;
